import {Client} from '../../../graphql/types'

const AFFILIATE_ID = 36669

export const overrideFor36669 = (accounts: any[], client: Client) => {
  if (client.affiliateId !== AFFILIATE_ID) return accounts
  if (client.id === 160987) return accounts // PT-4012

  return accounts.filter(account => !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype))
}
